import React, { Component } from 'react';
import masterCardIcon from './../../img/card-icon.svg';
import visaCardIcon from './../../img/visa-icon.svg';
import visaCardIconWhite from './../../img/visa-icon-white.svg';
import cardBlueBackground from './../../img/card-blue-background.svg';
import cardTransparentBackground from './../../img/card-transparent-background.svg';
import cardBlockIcon from './../../img/card-block-icon.png';
import { newRequest, request } from './../../../../config';
import { translate } from 'react-i18next';
import YesNoModal from './../../../../copms/Modal/YesNoModal';
import NotFound from '../../../../copms/NotFound/NotFound';
import Loading from './../../Loading/Loading';
import digitalCard from './../../img/digital_card.svg';
import otherCard from './../../img/other-bank-card.svg';
import { cardTypes, maskCardNumber, setPaymentTypeIcon } from '../../../../helpers/cards';
import smsConfirmationIcon from './../../img/sms-confirmation-icon.svg';
import commentAltLines from './../../img/comment-alt-lines.svg';
import DigitalCardActivation from '../DigitalCard/DigitalCardActivation/DigitalCardActivation';
import Switch from '@mui/joy/Switch';
import { getFormatedDate } from '../../../../helpers/fotmatDate';

class CardClickToPay extends Component {
    state = {
        card: null,
        open: false,
        isLoading: true,
        focusedInputIndex: 0,
        step: 0,
        timer: 180,
        phoneNumber: null,
        maskPhone: null,
        fromDigitalOrder: false,
        ctp: null,
        code: Array(6).fill(null).map(() => React.createRef())
    }

    showCard = () => {
        let customerType = localStorage.getItem('compId') == null ? 'Individual' : 'Juridical';
        let getCardByIdForCustomerRequestBody = (customerType === 'Individual') ? {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("card/getCardByIdFor" + customerType, getCardByIdForCustomerRequestBody))
            .then(res => res.text())
            .then((getCardByIdForCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCardByIdForCustomerResponse = JSON.parse(getCardByIdForCustomerResponseJSON);
                if (getCardByIdForCustomerResponse.status.statusCode !== 1) {
                    if (getCardByIdForCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    }
                }
                else {
                    if (getCardByIdForCustomerResponse?.otherCard) {
                        this.setState({ card: getCardByIdForCustomerResponse.otherCard }, () => { this.getCTPDataList(); });
                    } else {
                        // =========HOLDER=========
                        let holderArray = getCardByIdForCustomerResponse.holder.split(' ');
                        let lowercaseName = holderArray[0].toLowerCase();
                        let lowercaseSurname = holderArray[1].toLowerCase();
                        getCardByIdForCustomerResponse.organizedHolder = {
                            name: holderArray[0][0] + lowercaseName.substring(1, lowercaseName.length),
                            surname: holderArray[1][0] + lowercaseSurname.substring(1, lowercaseSurname.length)
                        };
                        getCardByIdForCustomerResponse.organizedCardNumber = getCardByIdForCustomerResponse.cardNumber.substring(0, 4)
                            + " **** **** " + getCardByIdForCustomerResponse.cardNumber.substring(12, 16);
                        let expiryDate = new Date(getCardByIdForCustomerResponse.expiryDate);
                        getCardByIdForCustomerResponse.organizedExpiryDate = {
                            month: (expiryDate.getMonth() < 9) ? ('0' + (expiryDate.getMonth() + 1)) : (expiryDate.getMonth() + 1),
                            year: expiryDate.getFullYear().toString().substring(2, 4),
                            fullYear: expiryDate.getFullYear(),
                            day: expiryDate.getDate() < 10 ? '0' + expiryDate.getDate().toString() : expiryDate.getDate().toString()
                        }
                        this.setState({ card: getCardByIdForCustomerResponse }, () => { this.getCTPDataList(); });
                    }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");

                });
    }

    getCTPDataList = () => {
        this.setState({ isLoading: true });
        let getCTPDataListRequestBody = {
            cardId: this.props.match.params.id
        }
        fetch(newRequest("visa/ctp/getCTPDataList", getCTPDataListRequestBody))
            .then(res => res.text())
            .then((getCTPDataListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCTPDataListResponse = JSON.parse(getCTPDataListResponseJSON);
                if (getCTPDataListResponse.status.statusCode !== 1) {
                    if (getCTPDataListResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    this.setState({ ctp: getCTPDataListResponse, isLoading: false });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");

                });
    }

    maskPhone = (phone) => {
        return '+' + phone.slice(0, 3) + '*****' + phone.slice(-4);
    }

    sendOtpForCardPinChange = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') == null ? 'Individual' : 'Juridical';
        let sendOtpCodeForSmsRequestBody = {
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            phoneNumber: customerType === 'Individual' ? JSON.parse(localStorage.getItem('custObject')).mobile : JSON.parse(localStorage.getItem('custObject')).customer.mobile,
        }
        fetch(newRequest("visa/ctp/sendOtpCodeForSms", sendOtpCodeForSmsRequestBody))
            .then(res => res.text())
            .then((sendOtpCodeForSmsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let sendOtpCodeForSmsResponse = JSON.parse(sendOtpCodeForSmsResponseJSON);
                if (sendOtpCodeForSmsResponse.status.statusCode === 1) {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({ verifyToken: sendOtpCodeForSmsResponse.verifyToken, phoneNumber: sendOtpCodeForSmsRequestBody.phoneNumber, maskPhone: this.maskPhone(sendOtpCodeForSmsRequestBody.phoneNumber), step: 1 }, () => {
                        setTimeout(() => this.state.code[0]?.current?.focus(), 0)
                        this.setTimer()
                    })
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(sendOtpCodeForSmsResponse.status.statusCode));
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");

                });
    }

    addCardCTP = (e) => {
        e.preventDefault();
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let addCardCTPRequestBody = {
            cardId: this.state.card.cardId,
            verifyTokenPhone: this.state.verifyToken,
            phoneNumber: this.state.phoneNumber,
            confirmCodePhone: this.state.code.map(item => item.current.value).join('')
        }
        fetch(newRequest("visa/ctp/addCardCTP", addCardCTPRequestBody))
            .then(res => res.text())
            .then((addCardCTPResponseJSON) => {
                const JSON = require('true-json-bigint');
                let addCardCTPResponse = JSON.parse(addCardCTPResponseJSON);
                if (addCardCTPResponse.status.statusCode === 1) {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t("VISA Click to Pay successfully added"), null, null, () => window.location.reload());
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(addCardCTPResponse.status.statusCode));
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");

                });
    }

    componentDidMount() {
        this.showCard();
    }

    handleAction = (status) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let requestBody = {
            cardId: this.state.card.cardId,
            status
        }
        fetch(newRequest("visa/ctp/updateCardCTP", requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode === 1) {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(response.status.statusCode), null, null, () => {
                        if (status === 'DELETED') {
                            this.props.history.push('/dashboard/home');
                        } else {
                            this.setState({ isLoading: true });
                            setTimeout(() => {
                                this.getCTPDataList();
                            }, 5000);
                        }
                    });
                }
                else {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
            });
    }

    setCardsBackground = (status, type) => {
        if (status) {
            if (type === cardTypes.DIGITAL_CARD || type === cardTypes.DIGITAL) {
                return <img src={digitalCard} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="active-digital-card" />
            } else if (type === cardTypes.CARD_STORAGE) {
                return <img src={otherCard} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="card-storage" />
            }
            else {
                return <img src={cardBlueBackground} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="cardBlueBackground" />
            }
        } else {
            if (type === cardTypes.DIGITAL_CARD || type === cardTypes.DIGITAL) {
                return <img src={digitalCard} className="dashboard-finance-section-card-section-details-section-content-card-background deactive-card" alt="deactive-digital-card" />
            } else if (type === cardTypes.CARD_STORAGE) {
                return <img src={otherCard} className="dashboard-finance-section-card-section-details-section-content-card-background deactive-card" alt="card-storage" />
            }
            else {
                return <img src={cardTransparentBackground} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="cardTransparentBackground" />
            }
        }
    }

    insertCodeNumber = (number) => {
        let { focusedInputIndex, code } = this.state;
        const element = code[focusedInputIndex]?.current;

        if (!element) return;

        const cleanValue = String(number).replace(/\D/g, '').substring(0, 1);
        element.value = cleanValue;

        if (focusedInputIndex < code.length - 1 && cleanValue) {
            this.setState({ focusedInputIndex: focusedInputIndex + 1 }, () =>
                code[focusedInputIndex + 1]?.current?.focus()
            );
        } else if (focusedInputIndex === code.length - 1) {
            this.setState({ focusedInputIndex: -1 }
            //     , () => {
            //     element.blur();
            // }
        );
        }
    };

    deleteCodeNumber = (index, event) => {
        let { code } = this.state;
        if (event.key === "Backspace") {
            const element = code[index]?.current;

            if (!element) return;

            if (element.value) {
                element.value = "";
            } else if (index > 0) {
                const prevElement = code[index - 1]?.current;
                if (prevElement) {
                    prevElement.value = "";
                    this.setState({ focusedInputIndex: index - 1 }, () => {
                        prevElement.focus();
                    });
                }
            }
        }
    };

    handleFocus = (index) => {
        this.setState({ focusedInputIndex: index })
    }

    fancyTimeFormat = (duration) => {
        var mins = ~~((duration % 3600) / 60);
        var secs = ~~duration % 60;
        var ret = "";
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    setTimer = () => {
        this.setState({ timer: 180 }, () => {
            this.timerInt = setInterval(() => {
                this.setState(prevState => {
                    if (prevState.timer <= 1) {
                        clearInterval(this.timerInt);
                        return { timer: 0 };
                    }
                    return { timer: prevState.timer - 1 };
                });
            }, 1000);
        });
    };

    // continue = (e) => {
    //     e.preventDefault();
    //     let { code } = this.state;
    //     const value = code.map(item => item.current.value).join('')
    //     this.setState(prevState => ({ ...(prevState.step === 1 ? { pin: value } : prevState.step === 2 ? { rePin: value } : { confirmCode: value }), focusedInputIndex: 0 }), () => {
    //         code.forEach(ref => {
    //             if (ref?.current) {
    //                 ref.current.value = "";
    //                 ref.current.disabled = false;
    //             }
    //         })
    //         if (this.state.step == 2) {
    //             this.state.pin !== this.state.rePin ?
    //                 this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t("The PIN was entered incorrectly"))
    //                 :
    //                 this.sendOtpForCardPinChange()
    //         } else if (this.state.step == 3) {
    //             this.cardPinChangeV2();
    //         } else {
    //             this.setState({ step: 2 })
    //         }
    //     });
    //     setTimeout(() => code[0]?.current?.focus(), 0)
    // }

    render() {
        let { card, open, isLoading, step, feedbackMessage, timer, code, mobile, ctp, maskPhone } = this.state;
        let { t } = this.props;
        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Visa Click to Pay')}</h2>
                    </div>
                </div>
                {isLoading ?
                    <div className="dashboard-container-main-section"><Loading /></div> : !card ? <NotFound /> : <>
                        <YesNoModal onClose={() => this.setState({ open: false })} ok={t('agree')} notOk={t('i do not agree')} title={t('get acquainted with the rules')} body={t('Visa Click to Pay terms of service')} open={open} triggerFunc={() => this.sendOtpForCardPinChange()} />
                        <div className="dashboard-container-main-section">
                            <div className="dashboard-finance-section-card-section">
                                <div className="dashboard-finance-section-card-section-details-section" style={{ width: '46%' }}>
                                    <div className="dashboard-finance-section-card-section-details-section-background">
                                        <div className="dashboard-finance-section-card-section-details-section-header">
                                            {
                                                card && card.cardId !== undefined &&
                                                <div className="dashboard-finance-section-card-section-details-section-header-left-side">
                                                    <img src={setPaymentTypeIcon(card.cardPaymentType, masterCardIcon, visaCardIcon)} className="dashboard-finance-section-card-section-details-section-header-image" alt="cardIcon" />
                                                    <h3 className="dashboard-finance-section-card-section-details-section-header-card-number">{card.cardType}</h3>
                                                </div>
                                            }
                                        </div>
                                        <div className="dashboard-finance-section-card-section-details-section-content pb-4">
                                            <div className="dashboard-finance-section-card-section-details-section-content-card">
                                                {this.setCardsBackground(card.cardStatus, card.cardType)}
                                                <div className="dashboard-finance-section-card-section-details-section-content-card-item dashboard-finance-section-card-section-details-section-content-other-card-item">
                                                    {
                                                        card && card.cardId !== undefined &&
                                                        <img src={setPaymentTypeIcon(card.cardPaymentType, masterCardIcon, visaCardIconWhite)} className="dashboard-finance-section-card-section-details-section-content-card-item-logo" alt="cardIcon" />
                                                    }
                                                    {
                                                        card && card.cardId !== undefined &&
                                                        <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-number-section">
                                                            <h4 className="dashboard-finance-section-card-section-details-section-content-card-item-card-number-content">{card.cardType === cardTypes.CARD_STORAGE ? maskCardNumber(card.cardNumber) : card.organizedCardNumber}</h4>
                                                            <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-number-title">{t('card number')}</p>
                                                        </div>
                                                    }
                                                    {
                                                        card && card.cardId !== undefined && card.cardType !== cardTypes.CARD_STORAGE &&
                                                        <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-details-section mt-4">
                                                            <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-owner-section">
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-owner-name">{card.organizedHolder.name} {card.organizedHolder.surname}</p>
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-owner-title">{t("owner's name")}</p>
                                                            </div>
                                                            <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-valid-section">
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-valid-date">{card.organizedExpiryDate.month} / {card.organizedExpiryDate.year}</p>
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-valid-title">{t('it is reliable')}</p>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            {card && card.cardId !== undefined && card.cardType !== cardTypes.CARD_STORAGE &&
                                                (ctp.isVerify ?
                                                    <>
                                                        <ul className="dashboard-finance-section-card-section-details-section-content-list">
                                                            <li className="dashboard-finance-section-card-section-details-section-content-list-pin-item-switch">
                                                                <p>{ctp.isAddCTP ? t('Deactivate service') : t('Activate service')}</p>
                                                                <Switch checked={ctp.isAddCTP} onChange={() => this.handleAction(ctp.isAddCTP ? "DE_ACTIVE" : "ACTIVE")} />
                                                            </li>
                                                            {ctp.ctpList?.map((item, index) => (
                                                                <li key={index} className="dashboard-finance-section-card-section-details-section-content-list-pin-item-switch">
                                                                    <p>{item?.statusName}</p>
                                                                    <p>{getFormatedDate(item?.dataDate, 'dd.mm.yyyy')}</p>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                        <button type="button" onClick={() => this.handleAction("DELETED")} class="dashboard-payment-container-data-section-content-container-form-footer-button dashboard-payment-container-data-section-content-container-form-footer-button__gray ml-auto mt-4">{t('Delete')}</button>
                                                    </>
                                                    :
                                                    <ul className="dashboard-finance-section-card-section-details-section-content-list">
                                                        <li className="dashboard-finance-section-card-section-details-section-content-list-pin-item">
                                                            <button onClick={() => this.setState({ open: true })}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.944 3.25H14.056C15.894 3.25 17.35 3.25 18.489 3.403C19.661 3.561 20.61 3.893 21.359 4.641C22.107 5.39 22.439 6.339 22.597 7.511C22.687 8.184 22.724 8.967 22.739 9.874C22.7514 9.95007 22.7528 10.0275 22.743 10.104C22.749 10.6693 22.7513 11.2827 22.75 11.944V13C22.75 13.1989 22.671 13.3897 22.5303 13.5303C22.3897 13.671 22.1989 13.75 22 13.75C21.8011 13.75 21.6103 13.671 21.4697 13.5303C21.329 13.3897 21.25 13.1989 21.25 13V12C21.25 11.5547 21.2493 11.138 21.248 10.75H2.752C2.75 11.138 2.74933 11.5547 2.75 12C2.75 13.907 2.752 15.262 2.89 16.29C3.025 17.295 3.279 17.875 3.702 18.298C4.125 18.721 4.705 18.975 5.711 19.11C6.739 19.248 8.093 19.25 10 19.25H13C13.1989 19.25 13.3897 19.329 13.5303 19.4697C13.671 19.6103 13.75 19.8011 13.75 20C13.75 20.1989 13.671 20.3897 13.5303 20.5303C13.3897 20.671 13.1989 20.75 13 20.75H11.472H9.944C8.106 20.75 6.65 20.75 5.511 20.597C4.339 20.439 3.39 20.107 2.641 19.359C1.893 18.61 1.561 17.661 1.403 16.489C1.25 15.349 1.25 13.894 1.25 12.056V11.944C1.24866 11.2827 1.251 10.6693 1.257 10.104C1.24691 10.0276 1.24792 9.95012 1.26 9.874C1.276 8.967 1.313 8.184 1.403 7.511C1.561 6.339 1.893 5.39 2.641 4.641C3.39 3.893 4.339 3.561 5.511 3.403C6.651 3.25 8.106 3.25 9.944 3.25ZM2.776 9.25H21.224C21.2108 8.73513 21.1728 8.2212 21.11 7.71C20.975 6.705 20.721 6.125 20.298 5.702C19.875 5.279 19.295 5.025 18.289 4.89C17.262 4.752 15.907 4.75 14 4.75H10C8.093 4.75 6.739 4.752 5.71 4.89C4.705 5.025 4.125 5.279 3.702 5.702C3.279 6.125 3.025 6.705 2.89 7.71C2.83 8.155 2.796 8.662 2.776 9.249M18 14.75C17.4033 14.75 16.831 14.9871 16.409 15.409C15.9871 15.831 15.75 16.4033 15.75 17C15.75 17.5967 15.9871 18.169 16.409 18.591C16.831 19.0129 17.4033 19.25 18 19.25C18.5967 19.25 19.169 19.0129 19.591 18.591C20.0129 18.169 20.25 17.5967 20.25 17C20.25 16.4033 20.0129 15.831 19.591 15.409C19.169 14.9871 18.5967 14.75 18 14.75ZM14.25 17C14.2502 16.4153 14.3871 15.8388 14.6497 15.3164C14.9124 14.7941 15.2936 14.3404 15.7628 13.9916C16.2321 13.6428 16.7764 13.4085 17.3523 13.3075C17.9282 13.2065 18.5197 13.2416 19.0796 13.4099C19.6395 13.5782 20.1523 13.8752 20.5771 14.277C21.0018 14.6788 21.3267 15.1743 21.5258 15.7241C21.725 16.2738 21.7928 16.8625 21.7239 17.4431C21.655 18.0237 21.4513 18.5801 21.129 19.068L22.03 19.97C22.1037 20.0387 22.1628 20.1215 22.2038 20.2135C22.2448 20.3055 22.2668 20.4048 22.2686 20.5055C22.2704 20.6062 22.2518 20.7062 22.2141 20.7996C22.1764 20.893 22.1203 20.9778 22.049 21.049C21.9778 21.1203 21.893 21.1764 21.7996 21.2141C21.7062 21.2518 21.6062 21.2704 21.5055 21.2686C21.4048 21.2668 21.3055 21.2448 21.2135 21.2038C21.1215 21.1628 21.0387 21.1037 20.97 21.03L20.068 20.129C19.5028 20.5027 18.8469 20.7162 18.17 20.7469C17.4931 20.7776 16.8205 20.6244 16.2238 20.3034C15.627 19.9825 15.1284 19.5059 14.7808 18.9242C14.4333 18.3425 14.2499 17.6776 14.25 17ZM5.25 16C5.25 15.8011 5.32902 15.6103 5.46967 15.4697C5.61032 15.329 5.80109 15.25 6 15.25H10C10.1989 15.25 10.3897 15.329 10.5303 15.4697C10.671 15.6103 10.75 15.8011 10.75 16C10.75 16.1989 10.671 16.3897 10.5303 16.5303C10.3897 16.671 10.1989 16.75 10 16.75H6C5.80109 16.75 5.61032 16.671 5.46967 16.5303C5.32902 16.3897 5.25 16.1989 5.25 16Z" fill="#222222" />
                                                                    <path d="M14 17C14 14.7909 15.7909 13 18 13H19.195C21.3265 13 23.0836 14.6714 23.19 16.8003L23.2667 18.3331C23.3893 20.7851 21.2945 22.7678 18.8529 22.5108L17.5813 22.377C15.5455 22.1627 14 20.446 14 18.399V17Z" fill="white" />
                                                                    <path d="M14.7483 13.7678L13.9521 12.9645M18.9945 13.7678L19.7907 12.9645M13.9515 18.8579L14.7478 18.054M16.8711 12.697V11.625M13.6861 15.9112H12.625M20.1406 19.1195L22.2065 18.3038C22.2564 18.2838 22.2991 18.2494 22.3292 18.2049C22.3593 18.1605 22.3754 18.108 22.3754 18.0543C22.3754 18.0006 22.3593 17.9482 22.3292 17.9037C22.2991 17.8592 22.2564 17.8248 22.2065 17.8049L17.2422 15.8467C17.1938 15.828 17.1411 15.8238 17.0904 15.8346C17.0397 15.8454 16.9933 15.8708 16.9568 15.9076C16.9203 15.9444 16.8953 15.991 16.8849 16.0418C16.8745 16.0925 16.8791 16.1452 16.8982 16.1934L18.8385 21.2044C18.9262 21.4319 19.2447 21.4319 19.3325 21.2044L20.1406 19.1195Z" stroke="#222222" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                                <p>{t('Add to VISA Click to Pay')}</p>
                                                            </button>
                                                        </li>
                                                    </ul>)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-finance-section-card-section-operation-section" style={{ width: '51%' }}>
                                    <div className="dashboard-finance-section-card-section-operation-section-background">
                                        {step == 1 ?
                                            <div className="dashboard-finance-section-card-section-details-section-content-pin">
                                                <form className="dashboard-finance-section-card-section-details-section-content-pin-content">
                                                    <h3>{t('Enter the one-time code')}</h3>
                                                    <p>{t('OTP has been sent to your number', { phoneNumber: maskPhone })}</p>
                                                    <img src={smsConfirmationIcon} className="registration-container-icon" alt="smsConfirmationIcon" />
                                                    <div className="registration-container-sms-confirmation">
                                                        {code.map((ref, index) => (
                                                            <input
                                                                autoComplete="off"
                                                                key={index}
                                                                className={`registration-container-sms-confirmation-numbers ` + index}
                                                                ref={ref}
                                                                type="text"
                                                                value={code[index]?.current?.value}
                                                                placeholder="0"
                                                                autoFocus={index === 0}
                                                                onInput={(e) => this.insertCodeNumber(e.target.value)}
                                                                onFocus={() => this.handleFocus(index)}
                                                                onKeyDown={(e) => this.deleteCodeNumber(index, e)}
                                                            />
                                                        ))}
                                                    </div>
                                                    {feedbackMessage ? <p className="registration-container-validation-feedback-message" style={{ color: 'red' }}>{t(feedbackMessage)}</p> : null}
                                                    <div className="registration-container-resend w-100">
                                                        <div className="registration-container-resend-container">
                                                            <div className="registration-container-resend-container-icon">
                                                                <img src={commentAltLines} className="registration-container-resend-container-icon-img" alt="commentAltLines" />
                                                            </div>
                                                            <button type='button' className="registration-container-resend-container-button" disabled={timer != 0} onClick={() => this.sendOtpForCardPinChange()}>{t('resend the code')}</button>
                                                        </div>
                                                        <span className="registration-container-resend-timer">{this.fancyTimeFormat(timer)}</span>
                                                    </div>
                                                    <div className="dashboard-finance-section-card-section-details-section-content-pin-content-footer-button-group">
                                                        <button type='button' onClick={() => window.location.reload()}>{t("Back")}</button>
                                                        <button type='submit' className={code.every(item => item.current?.value) && timer ? 'active' : ''} disabled={!code.every(item => item.current?.value) || !timer} onClick={(e) => this.addCardCTP(e)}>{t("continue")}</button>
                                                    </div>
                                                </form>
                                            </div>
                                            :
                                            <div className="dashboard-last-operations-section-content pt-5">
                                                <img src={cardBlockIcon} alt="cardBlockIcon" className="dashboard-last-operations-section-content-image mt-5" />
                                                <p className="dashboard-last-operations-section-content-status mb-4">{t('Pay faster and securely with one click without entering card details for each payment')}</p>
                                                <ul className="dashboard-last-operations-section-content-invisible-list">
                                                    <li className="dashboard-last-operations-section-content-invisible-list-item">
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                                        </div>
                                                    </li>
                                                    <li className="dashboard-last-operations-section-content-invisible-list-item">
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                                        </div>
                                                    </li>
                                                    <li className="dashboard-last-operations-section-content-invisible-list-item">
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
        )
    }
}

export default translate("translation")(CardClickToPay);